/**
 * @generated SignedSource<<dea7f9000c4d138ff02e058f6ec3caa3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeliverKind = "EQUAL" | "WEIGHT" | "%future added value";
export type UpdateDeliverableInput = {
  clientMutationId?: string | null;
  deliverableId: string;
  deliverKind: DeliverKind;
};
export type ChatbotDetailPageContainer_updateDeliverKindMutation$variables = {
  input: UpdateDeliverableInput;
};
export type ChatbotDetailPageContainer_updateDeliverKindMutationVariables = ChatbotDetailPageContainer_updateDeliverKindMutation$variables;
export type ChatbotDetailPageContainer_updateDeliverKindMutation$data = {
  readonly updateDeliverable: {
    readonly deliverable: {
      readonly id: string;
      readonly deliverKind: DeliverKind | null;
    };
  } | null;
};
export type ChatbotDetailPageContainer_updateDeliverKindMutationResponse = ChatbotDetailPageContainer_updateDeliverKindMutation$data;
export type ChatbotDetailPageContainer_updateDeliverKindMutation = {
  variables: ChatbotDetailPageContainer_updateDeliverKindMutationVariables;
  response: ChatbotDetailPageContainer_updateDeliverKindMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliverKind",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatbotDetailPageContainer_updateDeliverKindMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateDeliverablePayload",
        "kind": "LinkedField",
        "name": "updateDeliverable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "deliverable",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChatbotDetailPageContainer_updateDeliverKindMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateDeliverablePayload",
        "kind": "LinkedField",
        "name": "updateDeliverable",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "deliverable",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c225ff592e441cff8990f093f591c4df",
    "id": null,
    "metadata": {},
    "name": "ChatbotDetailPageContainer_updateDeliverKindMutation",
    "operationKind": "mutation",
    "text": "mutation ChatbotDetailPageContainer_updateDeliverKindMutation(\n  $input: UpdateDeliverableInput!\n) {\n  updateDeliverable(input: $input) {\n    deliverable {\n      __typename\n      id\n      deliverKind\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4fe5db8cbc31670980345f6b4abadd41";

export default node;
